import { useAuth } from '@/context/AuthContext';

/**
 * Returns the merchant_id for the current authenticated user.
 * `/me` (AuthContext) already carries it — no separate fetch needed.
 */
export function useMerchantId() {
  const { user, loading } = useAuth();

  return { merchantId: user?.merchant_id ?? null, isLoading: loading };
}
